/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool



// give me the entire code to copy
// redesign just improve the product cards to add a little more pizzaz


// ─── ProductCard (Elegant Redesign) ─────────────────────────────────────────
// Fonts: add to your index.html <head>:
// <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&family=DM+Sans:wght@400;500&display=swap" rel="stylesheet" />

// make the product cards look elegant and polished with a lttle more pizzaz



// redesign this component to look more elegant and polished
// use tailwind css in the className directive 
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// do not change any functionality
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// Give me the complete code with instructions


//where is the css for the little arrow that appear when you hover an icon

// add hexOpacityColorSuffixes to seller config
// give me just the relevant code and instructions

import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaEye, FaHeart } from "react-icons/fa";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { FaUser } from "react-icons/fa6";

import { get_event_details } from '../../store/reducers/eventDetailsReducer';
import { add_to_cart, add_to_wishlist } from '../../store/reducers/cartReducer';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Modal2 from '../Modal2';
import { currencyFormat } from '../../components/CurrencyFormat';
import SkeletonWithImage from '../SkeletonWithImage';

const Rating = lazy(() => import('../Rating'));

// ─── Constants ────────────────────────────────────────────────────────────────

const CAROUSEL_RESPONSIVE = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
  desktop:           { breakpoint: { max: 3000, min: 1024 }, items: 1 },
  tablet:            { breakpoint: { max: 1024, min: 464  }, items: 1 },
  mobile:            { breakpoint: { max: 464,  min: 0    }, items: 1 },
};

const PAGE_CONFIGS = {
  Home: {
    iconSize: '34px', pageWidth: 'Wide',
    descLen: 28, nameLen: 30,
    buttonWidth: '98%', imageWidth: '98%',
  },
  default: {
    iconSize: '26px', pageWidth: 'Narrow',
    descLen: 22, nameLen: 22,
    buttonWidth: '95%', imageWidth: '98%',
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

const isVisible = (value) => value === 'Show';

const truncate = (str, len) =>
  str?.length > len ? `${str.substring(0, len)} ...` : str;

// ─── Sub-components ───────────────────────────────────────────────────────────

const ActionIcon = ({ onClick, className = '', style, tooltip, tooltipStyle, children, hidden }) => {
  if (hidden) return null;
  return (
    <li
      onClick={onClick}
      className={`
        w-[40px] h-[40px] cursor-pointer
        flex justify-center items-center
        rounded-full
        bg-white/90 backdrop-blur-sm
        shadow-md
        border border-white/60
        transition-all duration-200
        hover:scale-110 hover:shadow-lg
        ${className}
      `}
      style={style}
    >
      <div className="icon-container">
        <span className="icon flex justify-center items-center text-base">{children}</span>
        <div className="tooltip" style={tooltipStyle}>{tooltip}</div>
      </div>
    </li>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────

const Products = ({ title, products, parentPage }) => {
  const { userInfo }     = useSelector((state) => state.auth);
  const { seller }       = useSelector((state) => state.seller);
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ── Seller config ──────────────────────────────────────────────────────────
  const {
    _id: sellerId,
    frontEndPrimaryColor1:   primaryColor,
    frontEndPrimaryColor2:   primaryColor2,
    frontEndSecondaryColor1: secondaryColor,
    hexOpacityColorSuffixes: hexOpacityColorSuffixesRaw,  // ← add this
    shoppingTerm,
    productPluralTerm,
    isVisibleSitePayments,
    isVisibleSiteProductQuantities,
    isVisibleSiteWishlist,
    isVisibleSiteRating,
    isVisibleSiteChat,
  } = seller ?? {};
  
  const hexOpacityColorSuffixes = hexOpacityColorSuffixesRaw?.split(';') ?? [];
  const sellerColorSuffixDark = hexOpacityColorSuffixes[0] || 'FF';
  const sellerColorSuffixMedium = hexOpacityColorSuffixes[1] || '80';
  const sellerColorSuffixLight = hexOpacityColorSuffixes[2] || '1A';
    
  const showPayments   = isVisible(isVisibleSitePayments);
  const showQuantities = isVisible(isVisibleSiteProductQuantities);
  const showWishlist   = isVisible(isVisibleSiteWishlist);
  const showRating     = isVisible(isVisibleSiteRating);
  const showChat       = isVisible(isVisibleSiteChat);

  // ── Page config ────────────────────────────────────────────────────────────
  const config = useMemo(
    () => PAGE_CONFIGS[parentPage] ?? PAGE_CONFIGS.default,
    [parentPage]
  );
  const isWide = config.pageWidth === 'Wide';

  // ── Event-driven payment/quantity override ─────────────────────────────────
  const paymentsVisible = useMemo(() => {
    if (userInfo && eventDetails?.selectedSellerPackage && eventDetails.selectedSellerPackage !== 'None') {
      return false;
    }
    return showPayments;
  }, [userInfo, eventDetails, showPayments]);

  // ── Portion sizes ──────────────────────────────────────────────────────────
  const [portionSizes, setPortionSizes] = useState({});
  const setPortionSize = (productId, value) =>
    setPortionSizes((prev) => ({ ...prev, [productId]: value }));

  // ── Modal ──────────────────────────────────────────────────────────────────
  const [modalProduct, setModalProduct] = useState(null);

  // ── Effects ────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (userInfo?.id) dispatch(get_event_details(userInfo.id));
  }, [userInfo?.id, dispatch]);

  // ── Handlers ───────────────────────────────────────────────────────────────
  const handleAddToCart = (productId) => {
    if (!userInfo) return navigate('/login');
    dispatch(add_to_cart({
      userId: userInfo.id,
      quantity: 1,
      productId,
      portionSize: portionSizes[productId] ?? '',
    }));
    setPortionSize(productId, '');
  };

  const handleAddToWishlist = (pro) => {
    if (!userInfo) return navigate('/login');
    dispatch(add_to_wishlist({
      userId: userInfo.id,
      productId: pro._id,
      name: pro.name,
      price: pro.price,
      image: pro.images[0],
      discount: pro.discount,
      rating: pro.rating,
      slug: pro.slug,
      portionSizes: pro.portionSizes,
      description: pro.description,
      byThePan: pro.byThePan,
    }));
  };

  const handleChat = (chatTopic) => {
    navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
  };

  // ── Styles ─────────────────────────────────────────────────────────────────
  const tooltipStyle      = { color: 'white', backgroundColor: primaryColor + sellerColorSuffixDark };
  const brandBorderStyle  = { borderColor: primaryColor + sellerColorSuffixDark };
  const primaryTextStyle  = { color: primaryColor + sellerColorSuffixDark };
  const primaryBgStyle    = { backgroundColor: primaryColor + sellerColorSuffixDark, borderColor: primaryColor + sellerColorSuffixDark };
  const primaryBgStyle2   = { backgroundColor: primaryColor + sellerColorSuffixMedium };//99
  const tintBgStyle       = { backgroundColor: primaryColor +  + sellerColorSuffixLight }; // ~7% opacity tint
  //const ringStyle         = { outlineColor: primaryColor + '40' };

  // ── ButtonGroup ────────────────────────────────────────────────────────────
  const ButtonGroup = ({ next, previous }) => (
    <div className="flex justify-between items-center pb-1 mb-1 border-none border-black">
      {/* Title with left accent bar */}
      <div className="flex items-center gap-1.5">
        <div
          className="w-[5px] h-5 rounded-full"
          style={primaryBgStyle2}
        />
        <span
          className="text-sm font-semibold tracking-wide uppercase"
          style={primaryTextStyle}>
          {title}
        </span>
      </div>

      {/* Nav arrows products */}
      <div className={` flex items-center gap-1.5`}>
      
        <button
          onClick={previous}
          className="
            w-[28px] h-[28px] rounded-full
            flex justify-center items-center
            border transition-all duration-200
            hover:shadow-md hover:scale-110
            text-sm"
          style={{ ...brandBorderStyle, ...primaryTextStyle, backgroundColor: primaryColor + sellerColorSuffixLight }}>
          <IoIosArrowBack />
        </button>
        <button
          onClick={next}
          className="
            w-[28px] h-[28px] rounded-full
            flex justify-center items-center
            border transition-all duration-200
            hover:shadow-md hover:scale-110
            text-sm"
          style={{ ...brandBorderStyle, ...primaryTextStyle, backgroundColor: primaryColor + sellerColorSuffixLight }}>
          <IoIosArrowForward />
        </button>
      </div>
    </div>
  );

  // ── Product card ───────────────────────────────────────────────────────────
  const ProductCard = ({ pl }) => (
    <div
      className="group rounded-2xl overflow-hidden bg-white
        border
        shadow-sm
        transition-all duration-300 ease-out
        hover:-translate-y-1.5 hover:shadow-xl"
      style={{ 
        '--ring-color': primaryColor + sellerColorSuffixMedium, // for focus ring
        borderRadius: '8px',
        border: `2px solid ${primaryColor}${sellerColorSuffixMedium}`,
        boxShadow: `0 4px 20px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)`,
       }}>
      {/* ── Image zone ──  }*/}
      <div className="relative overflow-hidden h-[200px] md:h-[250px] xs:h-[160px]">
        {/* ── Accent top stripe ──────────────────────────────── */}
        <div className="h-[8px] w-full flex-shrink-0"
            style={{
                background: `linear-gradient(90deg, ${primaryColor}${sellerColorSuffixMedium} 0%, ${primaryColor} 50%, ${primaryColor}${sellerColorSuffixMedium} 100%)`,
            }}
        />
        {/* Subtle brand tint overlay on hover */}
        <div
          className="absolute inset-0 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ backgroundColor: primaryColor + sellerColorSuffixLight }}
        />

        <SkeletonWithImage
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          src={pl.images[0]}
          alt={pl.name}
        />

        {/* byThePan badge */}
        {pl.byThePan !== 'NoPan' && (
            <span
                className="absolute top-2.5 right-1 text-[11px] font-semibold tracking-wide
                    uppercase px-1.5 py-0 rounded-lg text-white shadow-md backdrop-blur-sm"
                style={{ backgroundColor: primaryColor + sellerColorSuffixDark, border: '1px solid white' }}>
                {pl.byThePan}
            </span>
        )}

        {/* Price floated on image bottom-left — fine-dining menu style 
        style={{ backgroundColor: 'rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.18)' }}
        */}
        {showPayments && (
            <span
                className="absolute top-2.5 left-1 text-[11px] font-semibold tracking-wide
                    px-1.5 py-0 rounded-lg text-white backdrop-blur-sm shadow-sm"
                style={{ backgroundColor: primaryColor + sellerColorSuffixDark, border: '1px solid white' }}>
                {currencyFormat.format(pl.price)}
            </span>
        )}

        {/* Action icons — glide up from bottom */}
        <ul
          className="
            absolute bottom-0 left-0 right-0 z-20
            flex justify-center items-center gap-2 pb-4
            translate-y-full group-hover:translate-y-0
            transition-transform duration-300 ease-out
          "
        >
          <ActionIcon
            onClick={() => handleAddToCart(pl._id)}
            style={{ color: primaryColor, borderColor: primaryColor + sellerColorSuffixDark }}
            tooltip={<>Add To<br />{shoppingTerm}</>}
            tooltipStyle={tooltipStyle}>
            <MdOutlineRestaurantMenu size={24} />
          </ActionIcon>

          <ActionIcon
            hidden={!showWishlist}
            onClick={() => handleAddToWishlist(pl)}
            style={{ color: primaryColor, borderColor: primaryColor + sellerColorSuffixDark }}
            tooltip={<>Add To<br />Wishlist</>}
            tooltipStyle={tooltipStyle}>
            <FaHeart size={20} />
          </ActionIcon>

          {/* Quick view */}
          <li>
            <Link
              onClick={() => setModalProduct(pl)}
              className="
                w-[40px] h-[40px] cursor-pointer
                flex justify-center items-center
                rounded-full
                bg-white/90 backdrop-blur-sm
                shadow-md
                border border-white/60
                transition-all duration-200
                hover:scale-110 hover:shadow-lg"
              style={{ 
                color: primaryColor + sellerColorSuffixDark, 
                borderColor: primaryColor + sellerColorSuffixDark, 
              }}>
              <div className="icon-container">
                <span className="icon flex justify-center items-center text-base"><FaEye size={22} /></span>
                <div className="tooltip" style={tooltipStyle}>Quick<br />View</div>
              </div>
            </Link>
          </li>

          <ActionIcon
            hidden={!showChat}
            onClick={() => handleChat(pl.name)}
            style={{ color: primaryColor + sellerColorSuffixDark, borderColor: primaryColor + sellerColorSuffixDark }}
            tooltip={<>Chat<br />With Us</>}
            tooltipStyle={tooltipStyle}>
            <IoChatbubbleEllipsesSharp size={20} />
          </ActionIcon>
        </ul>
      </div>

      {/* ── Info panel style={{ backgroundColor: secondaryColor ?? 'white' }} ── */}
      <div
        className="px-4 pt-3 pb-4 flex flex-col gap-1">
        {/* Product name */}
        <p className="text-sm font-semibold leading-snug"
          style={{ color: primaryColor + sellerColorSuffixDark }}>
          {truncate(pl.name, config.nameLen)}
        </p>

        {/* Price + Rating row */}
        <div className="flex items-center justify-between">
          {showRating && (
            <span className="flex items-center">
              <Suspense fallback={null}>
                <Rating ratings={pl.rating} />
              </Suspense>
            </span>
          )}
        </div>

        {/* Portion size select OR description pill */}
        {pl.portionSizes ? (
          <select
            value={portionSizes[pl._id] ?? ''}
            onChange={(e) => setPortionSize(pl._id, e.target.value)}
            className="
              w-full rounded-lg px-3 py-1.5
              text-xs font-medium
              border
              focus:outline-none focus:ring-2
              transition-all duration-150
              bg-transparent
            "
            style={{
              borderColor: primaryColor + sellerColorSuffixDark,
              color: primaryColor + sellerColorSuffixDark,
              focusRingColor: primaryColor + sellerColorSuffixLight,
            }}
          >
            <option value="">Choose Portion Size</option>
            {pl.portionSizes.split(';').map((p, i) => (
              <option key={i} value={p}>{p}</option>
            ))}
          </select>
        ) : (
          <div
            className="px-1 py-1.5 text-xs font-bold leading-snug"
            style={{ color: primaryColor + sellerColorSuffixMedium }}>
            {truncate(pl.description, config.descLen)}
          </div>
        )}
        
        {/* Add-to-cart button */}
        <button
          onClick={() => handleAddToCart(pl._id)}
          className="
            w-full h-[38px] mt-0.5
            flex justify-center items-center gap-1.5
            rounded-full
            text-sm font-semibold text-white
            shadow-sm border-2
            transition-all duration-200
            hover:shadow-md hover:brightness-105 hover:scale-[1.01]
            active:scale-[0.99]"
          style={primaryBgStyle}>
            {userInfo
                ? <><MdOutlineRestaurantMenu size={18} /> Add To {shoppingTerm}</>
                : <><FaUser size={16} /> Please Login</>}  
        </button>
        <Link 
            type="button"
            to='/shops'
            className={`  
                w-full rounded-full font-semibold tracking-widest uppercase
                transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]
                flex items-center justify-center gap-1.5 text-white
                shadow-sm hover:shadow-md mt-1 border-2 
                py-[7px] text-[12px]`}
            style={{ 
                borderColor: primaryColor + sellerColorSuffixDark, 
                color: primaryColor + sellerColorSuffixDark, 
                backgroundColor: primaryColor + sellerColorSuffixLight
                //<span className={` ${parentPage === 'productDetails' ? 'block' : 'hidden'} `}><br /></span> 
              
            }}>
            <div className='flex' >
              <MdOutlineRestaurantMenu 
                className={` ${parentPage === 'productDetails' ? 'text-[32px] mt-0.5 mr-1' : 'text-[17px] mr-0.5'} `} /> 
              <div className={` ${parentPage === 'productDetails' ? 'grid grid-cols-1' : 'grid grid-cols-2'} `}>
                <div className='mr-0.5'>Explore  All</div> 
                <div>{productPluralTerm}</div>
              </div>
            </div>
        </Link>
      </div>
      
    </div>
  );

  // ── Render  sm:w-[290px] xs:w-[290px] ─────────────────────────────────────────────────────────────────
  return (
    <div
      className={`
        ${isWide ? 'w-[318px]' : 'w-[250px]'}
        flex flex-col-reverse sm:w-[98%] xs:w-[98%]
        rounded-2xl gap-2 p-4
        bg-white backdrop-blur-sm
        border-2
        shadow-sm
      `} style = {{ borderColor: primaryColor + sellerColorSuffixDark ?? 'white' }}>
      <Carousel
        autoPlay={false}
        infinite={false}
        arrows={false}
        responsive={CAROUSEL_RESPONSIVE}
        transitionDuration={500}
        renderButtonGroupOutside={true}
        customButtonGroup={<ButtonGroup />}
      >
        {products.map((page, i) => (
          <div key={i} className="flex flex-col justify-start gap-3">
            {page.map((pl, j) => (
              <ProductCard key={pl._id ?? j} pl={pl} />
            ))}
          </div>
        ))}
      </Carousel>

      <Modal2 isOpen={!!modalProduct} onClose={() => setModalProduct(null)} product={modalProduct} />
    </div>
  );
};

export default Products;




//refactored
// import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FaEye, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { MdOutlineRestaurantMenu } from "react-icons/md";

// import { get_event_details } from '../../store/reducers/eventDetailsReducer';
// import { add_to_cart, add_to_wishlist } from '../../store/reducers/cartReducer';

// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';

// import Modal2 from '../Modal2';
// import { currencyFormat } from '../../components/CurrencyFormat';
// import SkeletonWithImage from '../SkeletonWithImage';

// const Rating = lazy(() => import('../Rating'));

// // ─── Constants ────────────────────────────────────────────────────────────────

// const CAROUSEL_RESPONSIVE = {
//   superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 1 },
//   desktop:           { breakpoint: { max: 3000, min: 1024 }, items: 1 },
//   tablet:            { breakpoint: { max: 1024, min: 464  }, items: 1 },
//   mobile:            { breakpoint: { max: 464,  min: 0    }, items: 1 },
// };

// const PAGE_CONFIGS = {
//   Home: {
//     iconSize: '34px', pageWidth: 'Wide',
//     descLen: 28, nameLen: 30,
//     buttonWidth: '98%', imageWidth: '98%',
//   },
//   default: {
//     iconSize: '26px', pageWidth: 'Narrow',
//     descLen: 22, nameLen: 22,
//     buttonWidth: '95%', imageWidth: '98%',
//   },
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// const isVisible = (value) => value === 'Show';

// const truncate = (str, len) =>
//   str?.length > len ? `${str.substring(0, len)} ...` : str;

// // ─── Sub-components ───────────────────────────────────────────────────────────

// const ActionIcon = ({ onClick, className = '', style, tooltip, tooltipStyle, children, hidden }) => {
//   if (hidden) return null;
//   return (
//     <li
//       onClick={onClick}
//       className={`w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all ${className}`}
//       style={style}
//     >
//       <div className="icon-container">
//         <span className="icon flex justify-center items-center">{children}</span>
//         <div className="tooltip" style={tooltipStyle}>{tooltip}</div>
//       </div>
//     </li>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────

// const Products = ({ title, products, parentPage }) => {
//   const { userInfo } = useSelector((state) => state.auth);
//   const { seller }   = useSelector((state) => state.seller);
//   const { eventDetails } = useSelector((state) => state.eventDetails);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // ── Seller config ──────────────────────────────────────────────────────────
//   const {
//     _id: sellerId,
//     frontEndPrimaryColor1:   primaryColor,
//     frontEndPrimaryColor2:   primaryColor2,
//     frontEndSecondaryColor1: secondaryColor,
//     shoppingTerm,
//     isVisibleSitePayments,
//     isVisibleSiteProductQuantities,
//     isVisibleSiteWishlist,
//     isVisibleSiteRating,
//     isVisibleSiteChat,
//   } = seller ?? {};

//   const showPayments   = isVisible(isVisibleSitePayments);
//   const showQuantities = isVisible(isVisibleSiteProductQuantities);
//   const showWishlist   = isVisible(isVisibleSiteWishlist);
//   const showRating     = isVisible(isVisibleSiteRating);
//   const showChat       = isVisible(isVisibleSiteChat);

//   // ── Page config (replaces 8 useState + useEffect) ──────────────────────────
//   const config = useMemo(
//     () => PAGE_CONFIGS[parentPage] ?? PAGE_CONFIGS.default,
//     [parentPage]
//   );
//   const isWide = config.pageWidth === 'Wide';

//   // ── Event-driven payment/quantity override ─────────────────────────────────
//   const paymentsVisible = useMemo(() => {
//     if (userInfo && eventDetails?.selectedSellerPackage && eventDetails.selectedSellerPackage !== 'None') {
//       return false;
//     }
//     return showPayments;
//   }, [userInfo, eventDetails, showPayments]);

//   // ── Portion sizes (per-product map, not shared state) ─────────────────────
//   const [portionSizes, setPortionSizes] = useState({});
//   const setPortionSize = (productId, value) =>
//     setPortionSizes((prev) => ({ ...prev, [productId]: value }));

//   // ── Modal ──────────────────────────────────────────────────────────────────
//   const [modalProduct, setModalProduct] = useState(null);

//   // ── Effects ────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (userInfo?.id) dispatch(get_event_details(userInfo.id));
//   }, [userInfo?.id, dispatch]);

//   // ── Handlers ───────────────────────────────────────────────────────────────
//   const handleAddToCart = (productId) => {
//     if (!userInfo) return navigate('/login');
//     dispatch(add_to_cart({
//       userId: userInfo.id,
//       quantity: 1,
//       productId,
//       portionSize: portionSizes[productId] ?? '',
//     }));
//     setPortionSize(productId, '');
//   };

//   const handleAddToWishlist = (pro) => {
//     if (!userInfo) return navigate('/login');
//     dispatch(add_to_wishlist({
//       userId: userInfo.id,
//       productId: pro._id,
//       name: pro.name,
//       price: pro.price,
//       image: pro.images[0],
//       discount: pro.discount,
//       rating: pro.rating,
//       slug: pro.slug,
//       portionSizes: pro.portionSizes,
//       description: pro.description,
//       byThePan: pro.byThePan,
//     }));
//   };

//   const handleChat = (chatTopic) => {
//     navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
//   };

//   // ── Styles ─────────────────────────────────────────────────────────────────
//   const tooltipStyle = { color: 'white', backgroundColor: primaryColor };
//   const brandStyle   = { color: primaryColor, borderColor: primaryColor, backgroundColor: secondaryColor };

//   // ── ButtonGroup (carousel nav + title) ────────────────────────────────────
//   const ButtonGroup = ({ next, previous }) => (
//     <div className="flex justify-between items-center">
//       <div className="text-md font-bold" style={{ color: primaryColor }}>{title}</div>
//       <div className="flex justify-center items-center gap-3 text-slate-600">
//         <button
//           onClick={previous}
//           className="w-[30px] h-[30px] border rounded-lg flex justify-center items-center"
//           style={brandStyle}
//         >
//           <IoIosArrowBack />
//         </button>
//         <button
//           onClick={next}
//           className="w-[30px] h-[30px] border rounded-lg flex justify-center items-center"
//           style={brandStyle}
//         >
//           <IoIosArrowForward />
//         </button>
//       </div>
//     </div>
//   );

//   // ── Product card ───────────────────────────────────────────────────────────
//   const ProductCard = ({ pl }) => (
//     <div
//       className="border-2 flex flex-col justify-start transition-all duration-1000 hover:-translate-y-2"
//       style={{ borderColor: primaryColor, backgroundColor: secondaryColor }}
//     >
//       {/* Image + hover actions */}
//       <div className="relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden">
//         <SkeletonWithImage
//             className="w-full h-[200px] md:h-[270px] xs:h-[180px] object-cover"
//             src={pl.images[0]}
//             alt={pl.name}
//         />

//         <ul className="group-hover:bottom-6 flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full">
//           <ActionIcon
//             onClick={() => handleAddToCart(pl._id)}
//             style={{ color: primaryColor, borderColor: primaryColor }}
//             tooltip={<>Add To<br />{shoppingTerm}</>}
//             tooltipStyle={tooltipStyle}
//           >
//             +<MdOutlineRestaurantMenu />&nbsp;
//           </ActionIcon>

//           <ActionIcon
//             hidden={!showWishlist}
//             onClick={() => handleAddToWishlist(pl)}
//             style={{ color: primaryColor, borderColor: primaryColor }}
//             tooltip={<>Add To<br />Wishlist</>}
//             tooltipStyle={tooltipStyle}
//           >
//             &nbsp;<FaHeart />&nbsp;
//           </ActionIcon>

//           {/* Quick view */}
//           <li>
//             <Link
//               onClick={() => setModalProduct(pl)}
//               className="w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all"
//               style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor }}
//             >
//               <div className="icon-container">
//                 <span className="icon flex justify-center items-center">&nbsp;<FaEye />&nbsp;</span>
//                 <div className="tooltip" style={tooltipStyle}>Quick<br />View</div>
//               </div>
//             </Link>
//           </li>

//           <ActionIcon
//             hidden={!showChat}
//             onClick={() => handleChat(pl.name)}
//             style={{ color: primaryColor, borderColor: primaryColor }}
//             tooltip={<>Chat<br />With Us</>}
//             tooltipStyle={tooltipStyle}
//           >
//             &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//           </ActionIcon>
//         </ul>
//       </div>

//       {/* Info panel */}
//       <div
//         className={`${isWide ? 'w-[284px]' : 'w-[216px]'} px-2 h-[124px] flex justify-start items-start flex-col`}
//       >
//         <span className="text-md font-semibold">
//           {truncate(pl.name, config.nameLen)}
//         </span>

//         <div className="grid grid-cols-2 justify-start items-center gap-0">
//           {paymentsVisible && (
//             <span className="text-md font-semibold">{currencyFormat.format(pl.price)}</span>
//           )}
//           {showRating && (
//             <span className="flex mb-1">
//               <Suspense fallback={null}>
//                 <Rating ratings={pl.rating} />
//               </Suspense>
//             </span>
//           )}
//         </div>

//         <div className="w-full">
//           {pl.portionSizes ? (
//             <select
//               value={portionSizes[pl._id] ?? ''}
//               onChange={(e) => setPortionSize(pl._id, e.target.value)}
//               className="border rounded-md px-3 py-1 mb-1 w-full text-[14px] font-semibold"
//               style={{ borderColor: primaryColor, color: primaryColor, backgroundColor: secondaryColor }}
//             >
//               <option value="">Choose Portion Size</option>
//               {pl.portionSizes.split(';').map((p, i) => (
//                 <option key={i} value={p}>{p}</option>
//               ))}
//             </select>
//           ) : (
//             <div
//               className="border px-1 py-1 mb-1 text-[14px] font-semibold"
//               style={{ ...brandStyle, width: config.buttonWidth }}
//             >
//               {truncate(pl.description, config.descLen)}
//             </div>
//           )}
//         </div>

//         <div className="w-full">
//           <button
//             onClick={() => handleAddToCart(pl._id)}
//             className="h-[34px] flex justify-center items-center rounded-lg text-md cursor-pointer hover:shadow-lg text-white"
//             style={{ backgroundColor: primaryColor, width: config.buttonWidth }}
//           >
//             <MdOutlineRestaurantMenu className="mr-1" />
//             Add To {shoppingTerm}
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <div
//       className={`${isWide ? 'w-[318px] border-2' : 'w-[250px] border-none'} flex rounded-lg gap-2 p-4 flex-col-reverse`}
//       style={{ color: primaryColor, borderColor: primaryColor }}
//     >
//       <Carousel
//         autoPlay={false}
//         infinite={false}
//         arrows={false}
//         responsive={CAROUSEL_RESPONSIVE}
//         transitionDuration={500}
//         renderButtonGroupOutside={true}
//         customButtonGroup={<ButtonGroup />}
//       >
//         {products.map((page, i) => (
//           <div key={i} className="flex flex-col justify-start gap-2">
//             {page.map((pl, j) => (
//               <ProductCard key={pl._id ?? j} pl={pl} />
//             ))}
//           </div>
//         ))}
//       </Carousel>

//       <Modal2 isOpen={!!modalProduct} onClose={() => setModalProduct(null)} product={modalProduct} />
//     </div>
//   );
// };

// export default Products;






//my original code
// import React, { useEffect, useState, lazy } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { IoIosArrowBack,IoIosArrowForward } from "react-icons/io";
// import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";
// import { FaEye, FaRegHeart, FaHeart } from "react-icons/fa";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { RiShoppingCartLine } from "react-icons/ri";
// import { MdOutlineRestaurantMenu } from "react-icons/md";

// import { get_event_details } from '../../store/reducers/eventDetailsReducer';
// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';

// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css'

// import Modal2 from '../Modal2';
// import toast from 'react-hot-toast';
// //import Rating from '../Rating';
// import { currencyFormat } from '../../components/CurrencyFormat';
// import SkeletonWithImage from '../SkeletonWithImage';

// import config from '../../config';

// const Rating  = lazy(()=> import('../Rating')) 

// const Products = ({title, products, parentPage}) => {
//     const { userInfo } = useSelector(state => state.auth)
//     const { seller } = useSelector(state => state.seller)
//     const { eventDetails } = useSelector(state => state.eventDetails)

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1
//     const sellerShoppingTerm = seller?.shoppingTerm
    
//     let sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     let sellerBoolShowSiteProductQuantities = seller?.isVisibleSiteProductQuantities === 'Show' ? true : false
//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show' ? true : false

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };

//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     const [portionSize, setPortionSize] = useState('')
//     const [iconHeight, setIconHeight] = useState('')
//     const [iconWidth, setIconWidth] = useState('')
//     const [pageWidth, setPageWidth] = useState('')
//     const [descriptionSubstringLength, setDescriptionSubstringLength] = useState('')
//     const [nameSubstringLength, setNameSubstringLength] = useState('')
//     const [buttonWidth, setButtonWidth] = useState('')
//     const [imageWidth, setImageWidth] = useState('')
    
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//       setModalProduct(product);
//     };
//     const closeModal = () => {
//       setModalProduct(null);
//     };

//     //const [displayTitle, setDisplayTitle] = useState('')    
//     //parentPage CategoryShop Home MainIngredientShop SearchProducts
    
//     useEffect(() => {
//         if (userInfo) {
//             dispatch(get_event_details(userInfo.id))
//         }
//     },[userInfo.id])

//     useEffect(() => { 
//         if (parentPage === 'Home') {
//             setIconHeight('34px')
//             setIconWidth('34px')
//             setPageWidth('Wide')
//             setDescriptionSubstringLength('28')
//             setNameSubstringLength('30')
//             setButtonWidth('98%')
//             setImageWidth('98%')
//         } else if (parentPage === 'Shops' || parentPage === 'SearchProducts' || parentPage === 'CategoryShop' || parentPage === 'MainIngredientShop') {
//             setIconHeight('26px')
//             setIconWidth('26px')
//             setPageWidth('Narrow')
//             setDescriptionSubstringLength('22')
//             setNameSubstringLength('22')
//             setButtonWidth('95%')
//             setImageWidth('98%')
//         }
//     },[parentPage])

//     const add_to_cart_local = (id) => {
//         if (userInfo) {
//             //console.log('productId ', id)
//             //console.log('userId ', userInfo.id)
//             dispatch(add_to_cart({
//                 userId: userInfo.id,
//                 quantity : 1,
//                 productId : id,// product._id,
//                 portionSize: portionSize
//             }))
//             setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }
    
//     const add_to_wishlist_local = (pro) => {
//         if (userInfo) {
//             //console.log(pro)
//             dispatch(add_to_wishlist({
//                 userId: userInfo.id,
//                 productId: pro._id,
//                 name: pro.name,
//                 price: pro.price,
//                 image: pro.images[0],
//                 discount: pro.discount,
//                 rating: pro.rating,
//                 slug: pro.slug,
//                 portionSizes: pro.portionSizes,
//                 description: pro.description,
//                 byThePan: pro.byThePan
//             }))
//         } else {
//             navigate('/login')
//         }
//     }

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
    
//      const setPaymentsAndQuantitiesLocal = () => {
//         if (userInfo) {
//             if (eventDetails?.selectedSellerPackage !== undefined) {
//                 //console.log('\neventDetails?.selectedSellerPackage \n', eventDetails?.selectedSellerPackage) 
//                 if (eventDetails) {
//                     if (eventDetails?.selectedSellerPackage !== 'None') {
//                         sellerBoolShowSitePayments = false
//                         sellerBoolShowSiteProductQuantities = false
//                     } else {
//                         //sellerBoolShowSitePayments = true
//                         //sellerBoolShowSiteProductQuantities = true
//                     }
//                     //console.log('sellerBoolShowSitePayments ', sellerBoolShowSitePayments)
//                 }
//             }
//         }
//     }

//     const responsive = {
//         superLargeDesktop:  { breakpoint: { max: 4000, min: 3000 }, items: 1 },
//         desktop:            { breakpoint: { max: 3000, min: 1024 }, items: 1 },
//         tablet:             { breakpoint: { max: 1024, min: 464 }, items: 1 },
//         mobile:             { breakpoint: { max: 464, min: 0 }, items: 1 }
//     }
    
//     const ButtonGroup = ({next,previous}) => {
//         return (
//             <div className='flex justify-between items-center'>
//                 { setPaymentsAndQuantitiesLocal() }
//                 <div className='text-md font-bold' style={{color:sellerPrimaryColor1}}>
//                     {title}
//                 </div>
//                 <div className='flex justify-center  items-center gap-3 text-slate-600'>
//                     <button onClick={() => previous()} 
//                         className='w-[30px] h-[30px] border rounded-lg flex justify-center items-center' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                         <IoIosArrowBack />
//                     </button>
//                     <button onClick={() => next()} 
//                         className='w-[30px] h-[30px] border rounded-lg flex justify-center items-center' 
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                         <IoIosArrowForward /> 
//                     </button>
//                 </div>
//             </div>
//         )
//     }
//     //<div className='flex gap-8 flex-col-reverse'>
//     return (
//         <div className={` ${pageWidth === 'Wide' ? 'w-[318px] border-2' : 
//             'w-[250px] border-none'} flex rounded-lg gap-2 p-4 flex-col-reverse`}
//             style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//             <Carousel autoPlay={false} infinite={false} arrows={false} responsive={responsive} 
//                 transitionDuration={500} renderButtonGroupOutside={true} customButtonGroup={<ButtonGroup/>} >
//                 {
//                     products.map((p,i) => {
//                         return(
//                             <div key={i} className='flex flex-col justify-start gap-2'>
//                             {
//                                 //hover:shadow-md 
//                                 p.map((pl, j) => 
//                                     <div key={j} className='border-2' 
//                                         style={{borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <div 
//                                             className='flex border-none justify-start items-start transition-all duration-1000 hover:-translate-y-2 flex-col'
//                                             style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                             <div className={``}>
//                                                 <div className={` relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden `} >
                                                    
//                                                     <div className='w-[98%] p-0.5 justify-items-center items-center flex' >
//                                                         <SkeletonWithImage className=' h-[200px] md:h-[270px] xs:h-[180px] xs:w-[180px] object-cover' 
//                                                             style={{borderColor:sellerPrimaryColor1}} src={pl.images[0]} alt="" />
//                                                     </div>
                                                    
//                                                     <ul className={`group-hover:bottom-6 flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full`}>
//                                                         { /* hover:bg-[#059473] hover:text-white hover:rotate-[720deg] */}
//                                                         <li onClick={() => add_to_cart_local(pl._id)} 
//                                                             className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                                             style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                             <div className="icon-container">
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     +<MdOutlineRestaurantMenu />&nbsp;
//                                                                 </span>
//                                                                 <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                                                             </div>
//                                                         </li>
//                                                         <li onClick={() => add_to_wishlist_local(pl)}
//                                                             className={` ${sellerBoolShowSiteWishList ? '' : 'hidden' } 
//                                                             w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all`}
//                                                             style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                             <div className="icon-container">
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     &nbsp;<FaHeart />&nbsp;
//                                                                 </span>
//                                                                 <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                                                             </div>
//                                                         </li>
//                                                         <li className='hidden' >
//                                                             <Link to={`/product/details/${pl._id}`}  
//                                                                 className='w-[38px] h-[38px] cursor-pointer flex justify-center items-center rounded-full  transition-all '>
//                                                                 <FaEye />
//                                                             </Link>
//                                                         </li>
//                                                         <li>
//                                                             <Link onClick={() => openModal(pl)}
//                                                                 className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                                 style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                                 <div className="icon-container">
//                                                                     <span className='icon flex justify-center items-center'>
//                                                                         &nbsp;<FaEye />&nbsp;
//                                                                     </span>
//                                                                     <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                                 </div>
//                                                             </Link>
//                                                         </li>
//                                                         {
//                                                         //     <div key={product.id} className="border rounded p-4">
//                                                         //     <img src={product.imageUrl} alt={product.name} className="mb-2" />
//                                                         //     <h3 className="text-lg font-semibold">{product.name}</h3>
//                                                         //     <button
//                                                         //       onClick={() => openModal(product)}
//                                                         //       className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
//                                                         //     >
//                                                         //       View Details
//                                                         //     </button>
//                                                         //   </div>
//                                                         }
//                                                         <span onClick={() => redirect_chat_page(pl.name)} 
//                                                             className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
//                                                             w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all` }
//                                                             style={{ backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                                             <div className="icon-container">
//                                                                 <span className='icon flex justify-center items-center'>
//                                                                     &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                                 </span>
//                                                                 <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                             </div>
//                                                         </span>
//                                                     </ul>
//                                                 </div>
//                                                 {/*${pageWidth === 'Wide' ? 'w-[286px]' : 'w-[206px]'} */}
//                                                 <div className={` ${pageWidth === 'Wide' ? 'w-[284px]' : 
//                                                     'w-[216px]'} px-2 h-[124px] border-none flex justify-start items-start flex-col`}>
//                                                     <span className={` text-md font-semibold`}>
//                                                         { 
//                                                             pl.name.length > nameSubstringLength ? pl.name.substring(0, nameSubstringLength) + ' ...' : pl.name
//                                                         } 
//                                                     </span>
//                                                     <div className='grid grid-cols-2 justify-start items-center gap-0' >
//                                                         {
//                                                             //console.log(pl.price) 
//                                                         }
//                                                         <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                                             {currencyFormat.format(pl.price)}
//                                                         </span>
//                                                         <span className={`${sellerBoolShowSiteRating ? 'flex mb-1' : 'hidden'} `}>
//                                                             <Rating ratings={pl.rating} />
//                                                         </span>
//                                                     </div>
//                                                     <div className='w-full' >
//                                                         <div className={`${pl.portionSizes !== '' ? 'w-[98%]' : 'hidden'} `}>
//                                                             <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                                                 className='border rounded-md px-3 py-1 mb-1 w-full text-[14px] font-semibold' 
//                                                                 style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                                                 <option value=''>Choose Portion Size</option>
//                                                                 {
//                                                                     pl.portionSizes.split(';').map((p,i) => {
//                                                                         return( <option key={i} value={p}>{p}</option> )
//                                                                     })
//                                                                 }
//                                                             </select>
//                                                         </div>
//                                                         <div className={`${pl.portionSizes === '' ? 'border px-1 py-1 mb-1 text-[14px] font-semibold' : 'hidden'} `}
//                                                             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1, width:buttonWidth}}>
//                                                             {pl.description?.substring(0, descriptionSubstringLength)} ...
//                                                         </div>
//                                                     </div>
//                                                     <div className='w-full' >
//                                                         <button onClick={() => add_to_cart_local(pl._id)} 
//                                                             className={`   h-[34px] flex justify-center items-center rounded-lg text-md cursor-pointer
//                                                             hover:shadow-lg hover:shadow-green-500/40] text-white`} 
//                                                             style={{backgroundColor:sellerPrimaryColor1, width:buttonWidth}}>
//                                                             <MdOutlineRestaurantMenu className='mr-1' />
//                                                             Add To {sellerShoppingTerm}
//                                                         </button> 
//                                                     </div>
//                                                     {
//                                                         //text-white sellerSecondaryColor1
//                                                         //flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3
//                                                         // icon bar
//                                                         // <div className={`  ${pageWidth === 'Wide' ? 'mt-5' : 'mt-7'} border rounded-lg`}
//                                                         // style={{borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}   >
//                                                         //     <div className={` hidden ${pageWidth === 'Wide' ? 'grid grid-cols-4' : 'grid grid-cols-4'}  pr-1`} >
//                                                         //         <div onClick={() => add_to_cart_local(pl._id)} 
//                                                         //             className={` m-1 border cursor-pointer flex justify-center items-center rounded-full 
//                                                         //             hover:rotate-[720deg] transition-all  bg-white hover:bg-[#059473] hover:text-white`}
//                                                         //             style={{borderColor:sellerPrimaryColor1, width:iconWidth, height:iconHeight}}>
//                                                         //             <MdOutlineRestaurantMenu />
//                                                         //         </div>
//                                                         //         <div onClick={() => add_to_wishlist_local(pl)} 
//                                                         //             className={` m-1 border cursor-pointer flex justify-center items-center rounded-full 
//                                                         //             hover:rotate-[720deg] transition-all bg-white hover:bg-[#059473] hover:text-white`}
//                                                         //             style={{borderColor:sellerPrimaryColor1, width:iconWidth, height:iconHeight}}>
//                                                         //             <FaRegHeart />
//                                                         //         </div>
//                                                         //         <div>
//                                                         //             <Link to={`/product/details/${pl._id}`}
//                                                         //                 className={` m-1 border cursor-pointer flex justify-center items-center rounded-full 
//                                                         //                 hover:rotate-[720deg] transition-all bg-white hover:bg-[#059473] hover:text-white`}
//                                                         //                 style={{borderColor:sellerPrimaryColor1, width:iconWidth, height:iconHeight}}>
//                                                         //                 <FaEye />
//                                                         //             </Link>
//                                                         //         </div>
//                                                         //         <div className={` m-1 border cursor-pointer flex justify-center 
//                                                         //             items-center rounded-full hover:rotate-[720deg] transition-all bg-white hover:bg-[#059473] hover:text-white  `}
//                                                         //             style={{borderColor:sellerPrimaryColor1, width:iconWidth, height:iconHeight}}>
//                                                         //             <IoChatbubbleEllipsesSharp />
//                                                         //         </div>
//                                                         //     </div>
//                                                         // </div>
//                                                     }
//                                                 </div>
//                                             </div>
                                            
//                                         </div> 
//                                     </div>
//                                 )
//                             }
//                             </div>      
//                         )
//                     })
//                 }
//             </Carousel>
//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />   
//         </div>        
//     );
// };

// export default Products;






